import * as React from "react";
import {AdminRegion} from "../../../model/RegionLoginContent.model";

export interface AdminLoginDraftContentBannerProps {
    region: AdminRegion;
    onPublish: (regionId: number) => void;
}

export const DRAFT_BANNER_TITLE = "Draft — not live";
export const DRAFT_BANNER_HERO_MISSING_TITLE = "Draft — not live · Hero Content is missing";
export const DRAFT_BANNER_HERO_MISSING_HINT = "Add Hero Content to enable publishing.";
export const PUBLISH_BUTTON_PREFIX = "Publish ";

const heroIsMissing = (region: AdminRegion): boolean =>
    !region.hero || (!region.hero.tagline && !region.hero.headline && !region.hero.description);

export const AdminLoginDraftContentBanner: React.FunctionComponent<AdminLoginDraftContentBannerProps> = ({region, onPublish}) => {
    const heroMissing = heroIsMissing(region);
    return (
        <div
            className="admin-login-content__publish-banner admin-login-content__publish-banner--draft"
            data-testid="admin-login-content__publish-banner">
            <div className="admin-login-content__publish-banner-content">
                <i className="fa-solid fa-pen-to-square" />
                <div>
                    <strong>{heroMissing ? DRAFT_BANNER_HERO_MISSING_TITLE : DRAFT_BANNER_TITLE}</strong>
                    {heroMissing && <p>{DRAFT_BANNER_HERO_MISSING_HINT}</p>}
                </div>
            </div>
            <button
                type="button"
                className="admin-login-content__btn--publish"
                disabled={heroMissing}
                onClick={() => onPublish(region.id)}>
                <i className="fa-solid fa-paper-plane" /> {PUBLISH_BUTTON_PREFIX}{region.regionName}
            </button>
        </div>
    );
};
